module.exports = {
  externalPayProviderSelector: {
    label: 'Seleccione su método de transferencia electrónica:',
  },
  paymentMethodInfo: {
    achpse: 'Será redirigido al sitio web de banco que selecciones para autorizar el débito de los fondos. Disponible para cuentas de ahorro, corrientes o depósitos electrónicos.',
    bancolombia: 'Disponible para cuentas corrientes y de ahorro. Al elegir este método de pago, será redirigido al sitio web de Bancolombia.',
  },
  fawryLabel: 'Pagar por Fawry',
};
